import { HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { UserProfileStore } from '../store/user-profile.store';
import { catchError, from, switchMap, throwError } from 'rxjs';

function isTrustedGraphRequest(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'https:' && parsedUrl.hostname === 'graph.microsoft.com';
  } catch {
    return false;
  }
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
const userProfileStore = inject(UserProfileStore);
const authService = inject(AuthService);
const authToken = userProfileStore.token();

  // Never inject API token into Graph requests
  if (isTrustedGraphRequest(req.url)) {
    return next(req);
  }

  const withAuth = (request: HttpRequest<unknown>, token?: string) => {
    if (!token) return request;
    return request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  };

  return next(withAuth(req, authToken ?? undefined)).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return from(authService.refreshApiToken())
          .pipe(
            switchMap((newToken) => {
              userProfileStore.SetToken(newToken);
              const retried = withAuth(req, newToken);
              return next(retried);
            }),
            catchError((refreshErr) => {
              console.error('Silent refresh failed', refreshErr);
              return throwError(() => error);
            })
          );
      }
      return throwError(() => error);
    })
  );
}